import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { BiData } from '@wix/da-bi/pkg/events';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import HiddenIcon from '@wix/da-ds/pkg/Icons/32x32/Hidden';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import HiddenLayout from './HiddenLayout';
import hiddenStyles from './Hidden.scss';
const MatureBlockedOverlay = (_param)=>{
    var { deviation , disableMatureFilter , overrideMatureFilter , pushUserSettingsModal  } = _param, props = _object_without_properties(_param, [
        "deviation",
        "disableMatureFilter",
        "overrideMatureFilter",
        "pushUserSettingsModal"
    ]);
    const { t  } = useTranslation();
    // todo: this is essentially the same as nsfg's 13+
    return /*#__PURE__*/ React.createElement(HiddenLayout, _extends({
        icon: /*#__PURE__*/ React.createElement(HiddenIcon, {
            size: IconSize.HUGE
        }),
        text: t('deviationview.blocked.mature.text'),
        button: /*#__PURE__*/ React.createElement(GhostButton, {
            variant: "main",
            size: "medium",
            onClick: ()=>overrideMatureFilter(deviation.deviationId),
            biData: BiData({
                evid: 305,
                typeid: deviation.typeId,
                itemid: deviation.deviationId
            })
        }, t('deviationview.blocked.showDeviationAnyway')),
        secondaryButton: /*#__PURE__*/ React.createElement(TextButton, {
            className: hiddenStyles['secondary-button'],
            size: "medium",
            variant: "main",
            onClick: pushUserSettingsModal,
            biData: BiData({
                evid: 306,
                typeid: deviation.typeId,
                itemid: deviation.deviationId
            })
        }, /*#__PURE__*/ React.createElement(Trans, {
            i18nKey: 'deviationview.blocked.openContentFilterModal'
        })),
        deviation: deviation
    }, props));
};
MatureBlockedOverlay.displayName = 'MatureBlockedOverlay';
export default MatureBlockedOverlay;
